import { map } from 'rxjs/operators';
import { Observable, OperatorFunction } from 'rxjs';
import { Action } from '@ngrx/store';

import { debugAction } from '@iss/wo-common/ngrx';

interface ApolloResultActions<TData, TCtx> {
  readonly loading?: Action;
  readonly error?: (error: Error | undefined, ctx: TCtx) => Action;
  readonly data?: (data: TData, ctx: TCtx) => Action;
}

type ApolloResult<TData, TCtx> = Readonly<{
  loading: boolean;
  error?: Error;
  errors?: readonly Error[];
  data?: TData;
  context?: TCtx;
}>;

export const mapApolloResultToActions =
  <TData, TCtx>(actions: ApolloResultActions<TData, TCtx>) =>
    (result: ApolloResult<TData, TCtx>): Action => {
      if (result.loading && actions.loading) {
        return actions.loading;
      }

      if (result.error && actions.error) {
        return actions.error(result.error, result.context!);
      }

      if (result.data != null && actions.data) {
        return actions.data(result.data, result.context!);
      }

      return debugAction('Cannot map Apollo Result to any action')();
    };

export const mapApolloResult = <TData, TCtx>(
  actions: ApolloResultActions<TData, TCtx>,
): OperatorFunction<ApolloResult<TData, TCtx>, Action> =>
  (source: Observable<ApolloResult<TData, TCtx>>) =>
    source.pipe(map(mapApolloResultToActions(actions)));
